<template>
  <div class="text-xs uppercase">
    <ProgressBar
      class="my-2 max-w-[16rem]"
      :show-text="false"
      :completed="progressBarValue"
    ></ProgressBar>
    <div class="flex gap-2 justify-between">
      <span v-if="cap.frequency" class="font-normal opacity-50">
        {{ cap.frequency }} <span v-if="!useShortText">Cap</span>
      </span>
      <span class="opacity-50">{{ progressText }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import ProgressBar from '@/components/common/ProgressBar.vue'

const props = defineProps({
  useShortText: {
    type: Boolean,
    default: false
  },
  cap: {
    type: Object,
    required: true,
    validator: (cap) => {
      return cap.triggerValue !== undefined && 
             cap.type !== undefined
    }
  }
})

const currentValue = computed(() => {
  return props.cap.currentValue !== undefined ? props.cap.currentValue : 0
})


const progressBarValue = computed(() => {
  const realValue = (currentValue.value / props.cap.triggerValue) * 100
  return realValue > 4 ? realValue : 4
})

const progressText = computed(() => {
  return props.cap.type === "payout"
    ? `$${currentValue.value}/${props.cap.triggerValue}`
    : `${currentValue.value}/${props.cap.triggerValue} Actions`
})
</script> 